"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavButtonType = void 0;
var NavButtonType;
(function (NavButtonType) {
    NavButtonType["Default"] = "DEFAULT";
    NavButtonType["BackButtonOnBottom"] = "BACK_BUTTON_ON_BOTTOM";
})(NavButtonType = exports.NavButtonType || (exports.NavButtonType = {}));
